import i18n from '@/utils/i18n'
import PageAll from '@/components/PageAll'

const languages = i18n.messages[i18n.locale].router
  
export default [
    {
        path: '/fota',
        name: 'fota',
		subheader: languages.fota.title,
        meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            permCode: "12",
            icon: "lock",
        },
        component: PageAll,
		children: [
			{
				path: '/fota',
				name: 'fota-firmware',
				component: resolve => require(['@/pages/fota/firmware/index'], resolve),
				meta: {
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					title: languages.fota.title1,
					permCode: "1201",
				},
			},
			{
				path: '/fota/upgrades',
				name: 'fota-upgrades',
				component: resolve => require(['@/pages/fota/upgrades/index'], resolve),
				meta: {
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					title: languages.fota.title2,
					permCode: "1202",
				},
			},
		]
    },
]
  